export default __webpack_public_path__ + "static/media/calculator.59f68c3f.svg";